"use client";

import { EventItem } from "@/app/interfaces/event";
import styles from "./eventCard.module.css";
import formatDateTag from "@/app/events/utils/dateFormatter";
import getDirectImageUrl from "@/app/events/utils/getDirectUrl";
import { useRouter } from "next/navigation";
import { useLocale } from "next-intl";

type Props = {
  event: EventItem,
  // this is passed for the translation as to be passed the value of translation
  // instead of passing the variable 't' that is holding the useTranslation
  // the passing will be explore={t('explore')} => which explore is the key of translation
  explore: string
  locale: string
};

export function EventCard({ event, explore, locale }: Props) {
  const router = useRouter();
  const handleClick = () => {
    router.push(`/events/${event.id}`)
  }
  return (
    <div key={event.id} className={styles.eventCard}>

      {/* Date Tag - Now part of the normal document flow */}
      <div className={styles.dateTag}>
        {formatDateTag(locale, event.date)}
      </div>

      {/* Poster Area */}
      <div className={styles.posterWrapper} onClick={handleClick}>
        <div className={styles.poster} style={{ backgroundImage: `url(${getDirectImageUrl(event.posterLink)})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>

        </div>

        {/* Base State Overlay (Explore + Category) */}
        <div className={styles.cardOverlay}>
          <span className={styles.exploreText}>{explore}</span>
          {event.secretariat?.id && (
            <span className={styles.categoryPill}>
              {event.secretariat.name}
            </span>
          )}
        </div>

        {/* Hover State Content */}
        <div className={styles.hoverInfo}>
          <div className={styles.hoverDescription}>
            {event.description}
          </div>

          {/* Explore & Category persistent in hover */}
          <div className={styles.hoverFooter}>
            <span className={styles.exploreText}>{explore}</span>
            {event.secretariat?.id && (
              <span className={styles.categoryPill}>
                {event.secretariat.name}
              </span>
            )}
          </div>
        </div>

      </div>
    </div>
  );
}